import pickupLogic from './class.pickupLogic.js';

document.addEventListener('DOMContentLoaded', function () {

	let checkoutButton = document.querySelector('.checkout-button');
	checkoutButton.textContent = 'Select Pickup Date before Checkout';
	checkoutButton.dataset.pickupDateSet = 'false';
	checkoutButton.addEventListener('click', function (e) {
		// do we have a pickup date, if so, carry on with 
		if ('true' === checkoutButton.dataset.pickupDateSet) {
			return;
		}
		e.preventDefault();
	})
	document.pickupLogic = new pickupLogic('#pickupdatepicker');

});

jQuery(document.body).on('updated_wc_div removed_from_cart wc_cart_emptied', function (e) {
	window.location.reload(true);
});
